// extracted by mini-css-extract-plugin
module.exports = {"flashColor":"#00E0C7","arrow":"wheel-warning-module--arrow--2A_aM","actions":"wheel-warning-module--actions--2y0RE","btn":"wheel-warning-module--btn--1dvcL"};